export type IIngestJobStatus =
    | "PENDING"
    | "SUBMITTING"
    | "RUNNING"
    | "COMPLETED"
    | "FAILED"
    | "START_FAILED"
    | "UNKNOWN";

export type IIngestMetadata = Record<string, unknown>;

export interface IIngestJob {
    id: string;
    resourceId: string;
    relativePath: string;
    metadata: IIngestMetadata;
    avidExecutionId: string | null;
    status: IIngestJobStatus;
    exitCode: number | null;
    exitDescription: string | null;
    createdAt: string;
    startedAt: string | null;
    finishedAt: string | null;
    updatedAt: string;
}

// Kept as a frontend view model because the Avid history endpoint returns an array.
export interface IIngestJobResult {
    content: IIngestJob[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export const emptyIngestJobResult: IIngestJobResult = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 0,
};

export interface IIngestLocation {
    id: string;
    label: string;
}

export interface IIngestLocationContent {
    name: string;
    relativePath: string;
    isDirectory: boolean;
    size: number;
    lastModified: string;
}

export interface ICreateAvidIngestRequest {
    resourceId: string;
    files: string[];
    metadata: IIngestMetadata;
}
